import CodeModel from '@/models/v5/code';
import Api from '@/lib/api/api';
import _ from 'underscore';



var DraftModel = CodeModel.extend({
    defaults: {
        agent_code: null,
        device_code: null,
        deployment_id: null,
    },
    // draft is special, because it needs a devicegroup to build its URL
    // therefore, draft should always be instantiated with its ID set to
    // a devicegroup ID
    initialize: function(options) {
        this.type = 'draft';
    },
    // Anytime draft information is sent to the server, it should be a POST
    isNew: function(){
        return true;
    },
    url: function(){
        return Api.urls.device_group_draft({ devicegroup_id: this.id});
    },
    /**
     * Check to see if the already-fetched draft has ever
     * been saved to the API. This will not yield the information
     * you seek if you have not already fetched the draft.
    */
    is_uninitialized: function is_uninitialized() {
        // Check that both agent_code and device_code are null,
        // meaning that the API has handed us back a draft for
        // something we've never tried to save before.
        // (null + null === 0) is always true.
        return (this.get('agent_code') + this.get('device_code')) === 0;
    },
    /**
     * sync must have agent_code and device_code, and it needs to not have
     * 'id' attached anywhere when sent to the server
     */
    sync: function save(method, model, options) {
        options = (options ? options : {});
        var jsonapi;
        if (!options.attrs) {
            jsonapi = model.toJsonApi && model.toJsonApi();
            if (jsonapi) {
                if (jsonapi.attributes) {
                    // API requires agent_code and device_code to be filled
                    // with something. If this is a brand new draft, these
                    // will be null, and if we're only saving one, this
                    // will cause an error unless we fill them out.
                    jsonapi.attributes.agent_code = jsonapi.attributes.agent_code ? jsonapi.attributes.agent_code : '';
                    jsonapi.attributes.device_code = jsonapi.attributes.device_code ? jsonapi.attributes.device_code : '';
                    delete jsonapi.attributes.generation_id;
                    // This ensures the picky server doesn't get a whiff of stuff
                    // that triggers it.
                    delete jsonapi.attributes.created_at;
                    delete jsonapi.attributes.sha;
                }
                options.attrs = { data: _(jsonapi).pick('attributes', 'type') };
            }
        }
        return CodeModel.prototype.sync(method, model, options);
    },
});
DraftModel.type = 'draft';

export default DraftModel;

